<template>
  <div ref="canvasContainerRef" class="canvas-container" :style="{ width: data.maxX + 'px', height: data.maxY + 'px' }">
    <div v-if="isFlowShow" class="flow-show"></div>
    <vue-flow
      ref="vueflowref"
      class="vue-flow-canvas"
      :key="data.flowKey"
      :zoom-on-scroll="false"
      :pan-on-drag="false"
      :pan-on-scroll="false"
      :zoom-on-pinch="false"
      :interaction-config="{
        zoomOnPinch: false,
        zoomOnDoubleClick: false, // 禁止双击缩放
        panOnDrag: false,
        panOnScroll: false
      }"
      :max-zoom="data.zoom"
      :min-zoom="data.zoom"
      :zoom-on-double-click="false"
      :nodes="flowNodes"
      :edges="flowEdges"
      :connectionMode="'strict'"
      @click="handleCanvasClick"
    >
      <template #node-custom="customNodeProps">
        <custom-node class="custom-node" :customData="customNodeProps" @cb="nodeCb" @cbMouseover="onNodeMouseMoveFun" @cbMouseout="onNodeMouseLeaveFun" />
      </template>
      <template #edge-custom="customEdgeProps">
        <custom-edge :nodes="flowNodes" :edges="flowEdges" :customData="customEdgeProps" :id="customEdgeProps.id" :source-x="customEdgeProps.sourceX" :source-y="customEdgeProps.sourceY" :target-x="customEdgeProps.targetX" :target-y="customEdgeProps.targetY" :source-position="customEdgeProps.sourcePosition" :target-position="customEdgeProps.targetPosition" :marker-end="customEdgeProps.markerEnd" :style="customEdgeProps.style" />
      </template>
    </vue-flow>
    <div v-if="data.isFlowCard" class="flow-card" :style="{ position: 'fixed', top: data.clientY + 'px', left: data.clientX + 'px' }">
      <node-info :mouseNodeInfo="data.mouseNodeInfo"></node-info>
    </div>
  </div>
</template>

<script setup>
import _ from 'lodash';
import useFlowStage from '@/hooks/flow-stage';
import { computed, onMounted, reactive, ref } from 'vue';
import { VueFlow, useVueFlow } from '@vue-flow/core';
import CustomNode from '../custom-node/custom-node.vue';
import CustomEdge from '../custom-edge/custom-edge.vue';
import NodeInfo from '../node-info/node-info.vue';
import { tools } from '@/utils/tools.js';
const { onNodeClick, onEdgeClick, setNodes, onNodeMouseMove, onNodeMouseLeave } = useVueFlow();
const { buildTree, getLevelToTree, flattenTreeByLevel, filterUniqueIds, deduplicateLayers } = useFlowStage();
const emits = defineEmits(['cb', 'cbScrollInit']);
const props = defineProps({
  flowInfo: {
    type: [Object],
    default: () => {}
  },
  nodes: {
    type: [Array],
    default: () => []
  },
  edges: {
    type: [Array],
    default: () => []
  },
  scrollableDivWidth: {
    type: [Number, String],
    default: 0
  }
});
const data = reactive({
  flowKey: 0,
  zoom: 1,
  maxX: '',
  maxY: '',
  treeData2: [],
  treeData5: [],
  offsetY: 40,
  parentNodes: [],
  childNodes: [],
  currentId: '',
  isFlowCard: false,
  clientX: 0,
  clientY: 0,
  // 鼠标点击位置距离浏览器的距离
  distanceFromRight: 0,
  conditionList: [],
  offsetWidth: 0,
  lineWidth: 60,
  mouseNodeInfo: null,
  isCurrentNode: null
});
const isFlowShow = ref(true);
const flowInfoStatus = computed(() => props.flowInfo.status);
const flowNodes = ref([]);
const flowEdges = ref([]);
const vueflowref = ref();
const canvasContainerRef = ref();
// 唯一选中
const uniIsCurrent = (data) => {
  let foundTrue = false;
  function recursiveProcess(node) {
    if (node.data && node.data.isCurrent) {
      if (foundTrue) {
        node.data.isCurrent = false;
      } else {
        foundTrue = true;
      }
    }
    if (node.children) {
      node.children.forEach(recursiveProcess);
    }
    return node;
  }
  return data?.map(recursiveProcess);
};
const isValidDateStr = (str) => {
  const dateRegex = /^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}$/;
  return dateRegex.test(str) && !isNaN(new Date(str).getTime());
};
const setNodesEdges = async () => {
  // NOT_START(0, "未开始"),
  // START(1, "进行中"),
  // PAUSE(2, "已挂起"),
  // REJECT(3, "已驳回"),
  // TERMINATE(4, "已终止"),
  // FINISHED(5, "已完成");
  // 处理节点
  flowNodes.value = props?.nodes.map((item) => {
    return {
      id: item.originId,
      adminId: item.id,
      type: 'custom',
      data: {
        label: item.name,
        status: item.status,
        isCurrent: item.status == 1 ? true : false,
        nodeAttr: item.type,
        businessData: item.businessData,
        startTime: isValidDateStr(item.startTime) ? tools.removeSeconds(item.startTime) : '',
        endTime: isValidDateStr(item.endTime) ? tools.removeSeconds(item.endTime) : '',
        execTime: item.execTime ? tools.convertSecondsToTimeFormat(Math.round((item.execTime * 1) / 1000)) : flowInfoStatus.value == 2 ? '---' : tools.getExecTime(item.startTime)
      },
      position: { x: 0, y: 0 },
      draggable: false
    };
  });
  if (flowNodes.value && flowNodes.value.length) {
    flowNodes.value = uniIsCurrent(flowNodes.value);
    let obj = flowNodes.value?.find((item) => item.data.isCurrent == true);
    // 此处增加逻辑  如果节点全部完成 则默认抛出第一个
    if (flowInfoStatus.value == 5) obj = flowNodes.value?.[0];
    emits('cb', obj);
  }
  console.log('vueflowref-2p', props.nodes);
  console.log('vueflowref-2', flowNodes.value);
  // 处理连接线
  flowEdges.value = props?.edges.map((item) => {
    return {
      id: item.id || Date.now().toString() + tools.randomString(),
      source: item.source,
      target: item.target,
      type: 'custom',
      animated: false,
      style: {
        stroke: `rgb(var(--success-4))`,
        strokeWidth: 1
      }
    };
  });
};
onNodeMouseMove((event) => {
  onNodeMouseMoveFun(event);
});
// 节点移入
const onNodeMouseMoveFun = _.debounce((event) => {
  console.log('onNodeMouseMoveFun-1', event);
  data.mouseNodeInfo = event.node;
  data.clientX = event.event.clientX - 15;
  data.clientY = event.event.clientY + 15;
  data.isFlowCard = true;
}, 300);
// 节点移出
onNodeMouseLeave((event) => {
  onNodeMouseLeaveFun(event);
});
const onNodeMouseLeaveFun = _.debounce((event) => {
  console.log('onNodeMouseMoveFun-2', event);
  data.isFlowCard = false;
}, 300);

const handleCanvasClick = () => {
  console.log('画布被点击了');
  data.isFlowCard = false;
};

onEdgeClick((event) => {
  onEdgeClickFun(event);
});
const onEdgeClickFun = _.debounce((event) => {
  if (data.distanceFromRight < 300) {
    data.clientX = event.event.clientX - 500;
    data.clientY = event.event.clientY + 10;
  } else if (data.distanceFromRight < 400) {
    data.clientX = event.event.clientX - 200;
    data.clientY = event.event.clientY + 10;
  } else {
    data.clientX = event.event.clientX - 250;
    data.clientY = event.event.clientY + 10;
  }
}, 100);

const getMaxLayout = async () => {
  // 获取节点y 坐标最大值
  var yValue = 0;
  data.treeData5.forEach((item) => {
    if (yValue < item.length) yValue = item.length;
  });
  data.maxY = yValue * 40 + 28;
  if (data.maxY <= 180) data.maxY = 180;
};

// 获取该ID所在数组的长度 与 level
const getNodeInfo = (treeData5, id) => {
  for (let i = 0; i < treeData5.length; i++) {
    const tree = treeData5[i];
    var node = {};
    tree.forEach((item, index) => {
      if (item.id === id) {
        node.xLevel = item.level;
        node.yIndex = index;
        node.sumNodeWidth = item.sumNodeWidth;
        node.yCount = tree.length;
      }
    });
    if (JSON.stringify(node) !== '{}') return node;
  }
  return null; // 如果没有找到指定的ID
};

//首先计算出每个元素之间的间隔，然后根据间隔和元素的高度，依次设置每个元素的 Y 位置，使其在容器中沿 y 轴均匀分布
const getXy = async () => {
  flowNodes.value.forEach((item) => {
    var node = getNodeInfo(data.treeData5, item.id);
    if (node) {
      // 间隔
      const spaceBetweenItems = (data.maxY - node.yCount * 28) / (node.yCount + 1);
      item.level = node.xLevel;
      item.yCount = node.yCount;
      item.sumNodeWidth = node.sumNodeWidth;
      item.position.x = (node.xLevel - 1) * data.lineWidth + node.sumNodeWidth;
      item.position.y = spaceBetweenItems * (node.yIndex + 1) + node.yIndex * 28;
    }
  });
  const lastNodeWidth = data.treeData5[data.treeData5.length - 1][0]?.nodeWidth;
  //  sumNodeWidth(data.treeData5.length - 1) X位置累加
  data.maxX = sumNodeWidth(data.treeData5.length - 1) + (data.treeData5.length - 1) * data.lineWidth + lastNodeWidth + 100;
  data.maxX = data.maxX > props.scrollableDivWidth ? data.maxX * 1 : props.scrollableDivWidth;
  var offset = data.maxX - (sumNodeWidth(data.treeData5.length - 1) + (data.treeData5.length - 1) * data.lineWidth + lastNodeWidth);
  if (offset > 0) {
    data.offsetWidth = offset / 2;
  } else {
    data.offsetWidth = 0;
  }
  flowNodes.value?.forEach((item) => {
    item.position.x = item.position.x + data.offsetWidth;
  });
};
// 获取当前节点的所有父级节点
const getParentsNodeAll = (data, id) => {
  const parentsWithIdNine = [];
  function findParents(node, path = []) {
    if (node.id == id) {
      parentsWithIdNine.push([...path, node]);
    } else {
      path.push(node);
      if (node.children) {
        for (var child of node.children) {
          findParents(child, path);
        }
      }
      path.pop();
    }
  }
  findParents(data[0]);
  return parentsWithIdNine;
};

// 获取当前节点的所有子级节点
const getChildsNodeAll = (data, targetId) => {
  const flattenedChildren = [];
  function findAndFlatten(node) {
    if (node.id == targetId) {
      if (node.children && node.children.length > 0) {
        for (const child of node.children) {
          flattenedChildren.push(child);
          findAndFlatten(child);
        }
      }
    } else {
      if (node.children && node.children.length > 0) {
        for (const child of node.children) {
          findAndFlatten(child);
        }
      }
    }
  }
  findAndFlatten(data[0]);
  return flattenedChildren;
};

// 处理当前节点之前 处理当前节点之后
const arrangeNode = async () => {
  data.currentId = [];
  data.parentNodes = [];
  data.childNodes = [];
  flowNodes.value?.forEach((item) => {
    if (item.data.isCurrent) data.currentId.push(item.id);
  });
  if (data.currentId.length) {
    data.currentId.forEach((item) => {
      const ArrayP = getParentsNodeAll(JSON.parse(JSON.stringify(data.treeData2)), item);
      data.parentNodes = data.parentNodes.concat(ArrayP);
      const ArrayC = getChildsNodeAll(JSON.parse(JSON.stringify(data.treeData2)), item);
      data.childNodes = data.parentNodes.concat(ArrayC);
    });
  }
};

// 属于 当前节点 之前
const beforNode = async (id) => {
  let node = null;
  data.parentNodes?.forEach((item) => {
    item?.forEach((el) => {
      if (el.id == id) node = el;
    });
  });
  return node;
};

// 属于 当前节点 之后
const afterNode = (nodeList, targetId) => {
  for (const node of nodeList) {
    if (node.id == targetId) {
      return node;
    }
    if (node.children && node.children.length > 0) {
      const result = afterNode(node.children, targetId);
      if (result) {
        return result;
      }
    }
  }
  return null;
};
// 流程图加载完成回调
const onVueFlowMounted = async () => {
  let obj = null;
  flowNodes.value?.forEach((item) => {
    if (item.data.isCurrent == true) {
      obj = item;
    }
  });
  emits('cbScrollInit', JSON.parse(JSON.stringify(obj)));
};

const nodeCb = (nodecb) => {
  data.treeData5?.forEach((item) => {
    item?.forEach((el) => {
      if (el.id == nodecb.nodeId) el.nodeWidth = nodecb.nodeWidth + 4 > 145 ? 145 : nodecb.nodeWidth + 4;
    });
  });
};

const init = async () => {
  try {
    const treeData = await buildTree(flowNodes.value, flowEdges.value);
    data.treeData2 = await getLevelToTree(JSON.parse(JSON.stringify(treeData)));
    const treeData3 = await flattenTreeByLevel(JSON.parse(JSON.stringify(data.treeData2)));
    const treeData4 = await filterUniqueIds(treeData3);
    data.treeData5 = await deduplicateLayers(treeData4);
    await setNodeWidth();
    await getMaxLayout();
    await arrangeNode();
    await setEdgesColor();
    // 异步修改渲染后的样式 2025年03月18日17:57:31无法替换nextTick 替换后节点位置错乱
    setTimeout(() => {
      getXy();
      maxNodeWidth();
      onVueFlowMounted();
      isFlowShow.value = false;
    }, 0);
  } catch (error) {
    console.log(error);
    isFlowShow.value = false;
  }
};

onMounted(async () => {
  await setNodesEdges();
  init();
});

// 列 统一最大width
const maxNodeWidth = () => {
  data.treeData5?.forEach((item) => {
    let maxnum = 0;
    item?.forEach((el) => {
      if (el.nodeWidth > maxnum) {
        maxnum = el.nodeWidth;
      }
    });
    item?.forEach((el) => {
      flowNodes.value?.forEach((sub) => {
        if (el.id == sub.id) {
          sub.data.nodeWidth = maxnum;
        }
      });
      setNodes(flowNodes.value);
    });
  });
};

// 列 设置width
const setNodeWidth = async () => {
  //2025年03月18日17:59:20无法替换nextTick 替换后节点与节点间间连线位置异常
  setTimeout(() => {
    if (data.treeData5) {
      for (let index = 0; index < data.treeData5.length; index++) {
        const children = data.treeData5[index];
        for (let subIndex = 0; subIndex < children.length; subIndex++) {
          data.treeData5[index][subIndex].sumNodeWidth = sumNodeWidth(index);
        }
      }
    }
  }, 0);
};

// 列 累加width
const sumNodeWidth = (index) => {
  let num = 0;
  if (index <= 0) return num;
  for (let i = 0; index < data.treeData5.length; i++) {
    if (index == i) break;
    let maxnum = 0;
    data.treeData5[i]?.forEach((sub) => {
      if (sub.nodeWidth > maxnum) {
        maxnum = sub.nodeWidth;
      }
    });
    num = num + maxnum;
  }

  return num;
};

// 设置
const setEdgesColor = async () => {
  // 先处理 已完成 进行中
  flowNodes.value.forEach((item) => {
    if (item.data.status == 5) {
      setColor(item.id, false, 'rgb(var(--success-4))');
    } else if (item.data.status == 1) {
      setColor(item.id, false, 'rgb(var(--orange-4))');
    }
  });
  // 再处理 未开始
  flowNodes.value.forEach((item) => {
    if (item.data.status == 0) setColorNot(item.id, true, 'var(--color-neutral-4)');
  });
  data.flowKey = data.flowKey + 1;
};
const setColor = (nodeId, status, color) => {
  flowEdges.value.forEach((el) => {
    if (el.target == nodeId) {
      // el.animated = status;
      el.style.stroke = color;
      el.style.strokeWidth = 1;
    }
  });
};
const setColorNot = (nodeId, animatedStatus, color) => {
  flowEdges.value.forEach((el) => {
    if (el.target == nodeId || el.source == nodeId) {
      // el.animated = animatedStatus;
      el.style.stroke = color;
      el.style.strokeWidth = 1;
    }
  });
};

// 单击
onNodeClick(async (event) => {
  const res1 = await beforNode(event.node.id);
  const res2 = await afterNode(data.childNodes, event.node.id);
  event.node.data.isType = 'none';
  if (data.currentId.includes(event.node.id)) {
    event.node.data.isType = 'current';
  } else if (res1) {
    event.node.data.isType = 'befor';
  } else if (res2) {
    event.node.data.isType = 'after';
  }
  await handleNodes();
  event.node.data.isCurrent = true;
  emits('cb', event.node);
});
// 处理所有节点数据
const handleNodes = async () => {
  flowNodes.value?.forEach((item) => {
    item.data.isCurrent = false;
  });
};

const setflowKey = async () => {
  await setNodesEdges();
  init();
};

defineExpose({ setflowKey, init });
</script>
<style scoped lang="less">
@import './draw-flow.less';
</style>
<style>
/* import the necessary styles for Vue Flow to work */
@import '@vue-flow/core/dist/style.css';

/* import the default theme, this is optional but generally recommended */
@import '@vue-flow/core/dist/theme-default.css';
</style>
